import React, { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    return <Navigate to={location.state?.from || "/fiok"} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate(location.state?.from || "/fiok", { replace: true });
    } catch (err) {
      setError(err.message || "Bejelentkezés sikertelen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-16">
      <h1 className="text-3xl font-bold mb-2">Bejelentkezés</h1>
      <p className="text-gray-600 mb-8">
        Nincs fiókod?{" "}
        <Link className="text-blue-700 underline" to="/regisztracio">
          Regisztráció
        </Link>
      </p>

      <form onSubmit={onSubmit} className="space-y-4">
        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 text-red-800 px-3 py-2 text-sm">
            {error}
          </div>
        )}
        <label className="block">
          <span className="text-sm font-medium">E-mail</span>
          <input
            type="email"
            required
            autoComplete="email"
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">Jelszó</span>
          <input
            type="password"
            required
            autoComplete="current-password"
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <div className="flex items-center justify-between text-sm">
          <Link to="/jelszo-elfelejtve" className="text-blue-700 underline">
            Elfelejtett jelszó
          </Link>
        </div>
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-[#0c1a26] text-[#f5e9cb] rounded-lg py-2.5 font-medium hover:opacity-95 disabled:opacity-60"
        >
          {busy ? "Bejelentkezés…" : "Bejelentkezés"}
        </button>
      </form>
    </div>
  );
}
